import React from 'react';
import { Labeled } from '@1c/ui';
import formatDateTime from 'src/utils/formatDateTime';
import styles from './styles.module.scss';

type Props = {
  certificate: {
    version: string;
    subjectName: string;
    issuerName: string;
    validFromDate: string;
    validToDate: string;
    providerName: string;
    algorithmName: string;
  };
};

const CertificateDetails: React.FC<Props> = ({ certificate }) => (
  <div className={styles['certificate']}>
    <Labeled label={'Версия: '}>{certificate.version}</Labeled>
    <Labeled label={'Владелец: '}>{certificate.subjectName}</Labeled>
    <Labeled label={'Издатель: '}>{certificate.issuerName}</Labeled>
    <Labeled label={'Выдан: '}>{formatDateTime(certificate.validFromDate)}</Labeled>
    <Labeled label={'Действителен до: '}>{formatDateTime(certificate.validToDate)}</Labeled>
    <Labeled label={'Криптопровайдер: '}>{certificate.providerName}</Labeled>
    <Labeled label={'Алгоритм ключа: '}>{certificate.algorithmName}</Labeled>
  </div>
);

export default CertificateDetails;
